/*LOGIN*/
export const CODE_MULTI_FACTOR_AUTH = "AADSTS50076"
export const CODE_AUTH_EXPIRED = "AADSTS70008"